import { Box, Tabs, Tab } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

export const AdminTabs = ({ items }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const currentTabIndex = items.findIndex((item) => item.to === location.pathname);
  const activeTab = currentTabIndex >= 0 ? currentTabIndex : 0;

  const handleTabChange = (event, newValue) => {
    const selectedItem = items[newValue];
    if (selectedItem) {
      navigate(selectedItem.to);
    }
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 0 }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        sx={{
          '& .MuiTab-root': {
            textTransform: 'none',
            fontFamily: 'Inter, sans-serif',
            fontSize: { xs: '0.775rem', sm: '0.875rem' },
            fontWeight: 500,
            minHeight: { xs: 42, sm: 44 },
            color: '#6B7280',
            padding: { xs: '8px 16px', sm: '10px 20px' },
            marginRight: { xs: 1, sm: 2 },
            '&:last-child': {
              marginRight: 0,
            },
          },
          '& .Mui-selected': {
            color: '#000000',
            fontWeight: 600,
            '& svg': {
              color: '#000000',
            },
          },
          '& .MuiTabs-indicator': {
            height: 3,
            borderRadius: '3px 3px 0 0',
            bgcolor: '#3E9663',
          },
        }}
      >
        {items.map((item) => (
          <Tab
            key={item.to}
            icon={<item.icon sx={{ fontSize: 20, mb: 0.5, color: 'inherit' }} />}
            iconPosition="start"
            label={item.label}
            sx={{
              flexDirection: 'row',
              gap: { xs: 0, sm: 1 },
              '&.Mui-selected': {
                color: '#000000',
                '& svg': {
                  color: '#000000',
                },
              },
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

AdminTabs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      to: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.elementType.isRequired,
    }),
  ).isRequired,
};
